import { defineStore } from 'pinia'

export const useSeoStore = defineStore('seo', () => {
  const pageType = ref('')
  const pageTitle = ref('')

  return { pageType, pageTitle }
})
